import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("g", {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
        })
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "StatusReady", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
